<script lang="ts" setup>
  import LockIcon from '~/components/icons/LockIcon.vue'

  import type { SubmenuItem } from '~/types/submenu'

  defineProps<{
    item: SubmenuItem
  }>()
</script>

<template>
  <NuxtLink
    :key="item.label"
    :class="{ 'pointer-events-none opacity-50': item.disabled }"
    :to="item.route"
    active-class="active"
    class="submenu-item"
  >
    <div class="flex items-center gap-2 text-content-title">
      <component :is="item.icon" v-if="item.icon" class="size-4" />
      <p class="text-xs+ font-medium">{{ item.label }}</p>
    </div>
    <div class="flex flex-col text-right">
      <p class="text-xs+ font-medium text-[#9fa5aa]">
        <LockIcon v-if="item.disabled" class="size-4" />
        <span v-else-if="item.sideValue">{{ item.sideValue }}</span>
      </p>
    </div>
  </NuxtLink>
</template>
